import BatteryRoot, { Props } from './Battery'

export default function Battery(props: Props) {
  return <BatteryRoot {...props} />
}
